import { React, useState } from 'react';
import styled from 'styled-components';

export default function FontScaleSelectInput(props) {
  const { defaultScale, setScale } = props;

  const [value, setValue] = useState(defaultScale);
  const [isClickedInput, setIsClickedInput] = useState(false);

  function handleChange(e) {
    setValue(e.target.value);
    // changeFn(e.target.value);
  }

  function onMouseDown() {
    setIsClickedInput(true);
  }

  function handleMouseUp(e) {
    setIsClickedInput(false);
    setScale(parseInt(e.target.value));
  }

  return (
    <TopLevelWrapper>
      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='default'>글자 크기</Text>
      <InputWrapper>
        {/* <SizeView isClicked={isClickedInput}>
          <SizeText>{value}%</SizeText>
        </SizeView> */}
        <Input 
          type='range'
          min={0}
          max={100}
          value={value || ''}
          onChange={handleChange}
          onMouseDown={onMouseDown}
          onMouseUp={handleMouseUp}/>
      </InputWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const SizeView = styled.div`
  position: absolute;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  opacity: ${props => props.isClicked ? 1 : 0};

  margin-top: -50px;

  width: 88px;
  height: 28px;

  border-radius: 20px;
  background-color: #FF8B48;

  transition: all 0.3s ease-in-out;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;
`;

const Input = styled.input`
  width: 200px;
  height: 4px;

  border-radius: 8px;
  background-color: #515151;

  -webkit-appearance: none;

  ::-webkit-slider-thumb {
    -webkit-appearance: none;

    width: 12px;
    height: 12px;
    border-radius: 12px;

    background-color: #FF8B48;

    :hover {
      cursor: pointer;
    }
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;
   
  :hover {
    cursor: ${props => props.cursor};
  }

  transition: all 0.3s ease-in-out;
`;